import React from 'react'

export const SingleNotifcationLogRow = ({props}:any) => {
    const {
        notification_id,
        target,
        application_type,
        lead_ids,
        notification_status,
        source,
        trigger_date,
        trigger_time,
        schedule_date,
        schedule_time,
      } = props;
    return (
        <tr>
          <td>{notification_id}</td>
          <td>{application_type}</td>
          <td>{target || "Individual"}</td>
          {/* <td>{lead_ids.join(", ")}</td> */}
          <td>{notification_status}</td>
          <td>{source}</td>
          <td>{schedule_date}</td>
          <td>{schedule_time}</td>
          <td>{trigger_date}</td>
          <td>{trigger_time}</td>
        </tr>
      );
}
